import './styles.styl';
import { render } from 'base/wrapped-render';
import { PoMicroFrontend } from 'micro-frontend.react';
import Ctrl, { onPjaxEnd, onReady } from 'ctrl.deco';
import { isEnabled } from '@bamboohr/utils/lib/feature';

const renderDirectorySettings = () => {
	const directoryRefactorIsEnabled = isEnabled(
		'DIRECTORY_SETTINGS_TWIG_SUNSET',
	);

	if (!directoryRefactorIsEnabled) {
		return;
	}

	const directoryRoot = document.getElementById('js-directorySettingsRoot');

	const data = window.directorySettingsData;

	if (directoryRoot) {
		render(
			<PoMicroFrontend route="/settings/directory" directoryData={data} />,
			directoryRoot,
		);
	}
};

@Ctrl('/settings/directory*')
class SettingsDirectory {
	@onReady()
	@onPjaxEnd()
	_readyHandler() {
		renderDirectorySettings();
	}
}
